const EventRegistration = () => {
  return (
    <div>EventRegistration</div>
  )
}

export default EventRegistration